import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import { ChartType, ChartOptions, ChartDataSets, ChartData } from "chart.js";
import {
  MultiDataSet,
  Label,
  monkeyPatchChartJsLegend,
  monkeyPatchChartJsTooltip,
} from "ng2-charts";
import * as Chart from "chart.js";
import {} from "ng2-charts";

@Component({
  selector: "app-dashboard-voice-admin-country",
  templateUrl: "./dashboard-voice-admin-country.component.html",
  styleUrls: ["./dashboard-voice-admin-country.component.css"],
})
export class DashboardVoiceAdminCountryComponent implements OnInit {
  showDataMainDashboard = false;
  showMsgMainDashboard = false;
  showCountryMainDashboard = false;
  showMsgCountryMainDashboard = false;
  showTrunkMainDashboard = false;
  showMsgTrunkMainDashboard = false;
  showGatewayMainDashboard = false;
  showMsgGatewayMainDashboard = false;
  showCAPMainDashboard = false;
  showMsgCAPMainDashboard = false;
  showProjectMainDashboard = false;
  showMsgProjectMainDashboard = false;
  showGlobalCountryMainDashboard = false;
  showMsgGlobalCountryMainDashboard = false;
  showFeedbackMainDashboard = false;
  showMsgFeedbackMainDashboard = false;
  globalAdmin = true;
  regAdmin = false;

  public Country; // = MYCASService.country;
  public DeviceTypeList: any[];
  public Device;
  public ErrorMessage;
  public Countries: any[];
  public LoginEnterpriseID = "";
  public successfulData: any = [];
  public text;
  public options;
  public dataDashboard: any[];
  public labelsDashboard;
  public optionsGatewayDashboard;
  public dataGatewayDashboard;
  public labelsGatewayDashboard;
  public optionsCAPDashboard;
  public dataCAPDashboard;
  public labelsCAPDashboard;
  public optionsProjectDashboard;
  public dataProjectDashboard;
  public labelsProjectDashboard;
  public optionsGlobalCountryDashboard;
  public dataGlobalCountryDashboard;
  public labelsGlobalCountryDashboard;
  public optionsTrunkDashboard;
  //public optionsCountryDashboard;
  public dataCountryDashboard;
  public labelsCountryDashboard;
  public dataTrunkDashboard;
  public labelsTrunkDashboard;
  public dlstCountryModel;
  public filter;
  public dlstProjectNameModel;
  public Projects;

  public pieChartType: ChartType = "doughnut";
  public optionsCountryDashboard: ChartOptions = {};

  public DoughnutColors: any[] = [
    {
      backgroundColor: [
        "#52D726",
        "#FFEC00",
        "#FF7300",
        "#FF0000",
        "#007ED6",
        "#7CDDDD",
        "#9BBFE0",
        "#E8A09A",
        "#FBE29F",
        "#C6D68F",
      ],
    },
    {
      borderColor: [
        "#52D726",
        "#FFEC00",
        "#FF7300",
        "#FF0000",
        "#007ED6",
        "#7CDDDD",
        "#9BBFE0",
        "#E8A09A",
        "#FBE29F",
        "#C6D68F",
      ],
    },
  ];

  constructor(
    private router: Router,
    private capservice: CAPService,
    private _avRoute: ActivatedRoute
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Country = capservice.country;
  }

  ngOnInit(): void {
    this.successfulData = {};

    this.DeviceTypeList = [
      { name: "Cisco", id: "1" },
      { name: "Teams", id: "2" },
    ];
    this.ErrorMessage =
      "We didn't find any calls to display for this month. Please contact the Online support or check User Guidelines section for any access or tool issue.";
    this.GetCountryList();
    //this.InitialLoad();
  }
  GetCountryList() {
    this.capservice.CountryList("N", "N").subscribe((data) => {
      this.Countries = data;
    });
  }
  //initial loading

  InitialLoad() {
    this.capservice.getEntId().subscribe((data) => {
      this.LoginEnterpriseID = data[0].EnterpriseID;
      this.Country = data[0].Country.replace(/^\s+|\s+$/gm, "");

      //$rootScope._Country = this.Country;
    });
  }
  //Country load
  LoadCountryDashboardDetails(data, country, strType) {
    this.capservice
      .GetDashboard(data, this.LoginEnterpriseID, "N", country, strType)
      .subscribe((data) => {
        debugger;
        if (data.length > 0) {
          this.text = data[0].Country + " Calls";
          this.optionsCountryDashboard = {
            title: {
              display: true,
              fontColor: "#000000", //orange
              fontSize: 20,
              text: this.text,
            },
          };
          this.dataCountryDashboard = [];
          this.labelsCountryDashboard = [];
          this.successfulData = {
            voiceAdminCountryDashboard: data,
            selected: {},
          };
          for (let i = 0; i < data.length; i++) {
            if (data[i].CallType != null) {
              this.dataCountryDashboard.push(data[i].Cost);
              this.labelsCountryDashboard.push(data[i].CallType);
            } else {
              this.dataCountryDashboard = ["0"];
              this.labelsCountryDashboard = "No data Available";
            }
          }
          this.showCountryMainDashboard = true;
          this.showMsgCountryMainDashboard = false;
        } else {
          this.showCountryMainDashboard = false;
          this.showMsgCountryMainDashboard = true;
        }
      });
  }
  //On Country device type change
  DeviceTypeEventCountry() {
    debugger;
    this.filter = $("input[name=radioDeviceTypeCountry]:checked")
      .next()
      .text()
      .trim();
    this.Device = this.filter;
    if (this.Device != "" && this.Device != null && this.Device != undefined) {
      if (this.globalAdmin == true) {
        if (
          this.dlstCountryModel != "" &&
          this.dlstCountryModel != null &&
          this.dlstCountryModel != undefined
        ) {
          this.LoadCountryDashboardDetails(
            this.Device,
            this.dlstCountryModel,
            "VoiceAdminGlobalCountryDashboard"
          );
        } else {
          return alert("Please select country.");
        }
      } else {
        this.LoadCountryDashboardDetails(
          this.Device,
          "N",
          "VoiceAdminCountryDashboard"
        );
      }
    } else {
      return alert("Please select Device Type.");
    }
  }
}
